import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function Pricing() {
  return <section id="pricing" className="py-20 px-6 bg-cream" data-id="element-168">
      <div className="max-w-4xl mx-auto" data-id="element-169">
        {/* Qualification */}
        <div className="grid md:grid-cols-2 gap-12 mb-20" data-id="element-170">
          <div data-id="element-171">
            <h3 className="text-xl font-bold text-forest mb-6 uppercase tracking-wide" data-id="element-172">
              Esto es para ti si:
            </h3>
            <ul className="space-y-3 text-charcoal/90" data-id="element-173">
              <li className="flex gap-3" data-id="element-174">
                <span className="text-forest" data-id="element-175">✓</span>
                Estás cansada de improvisar entre paydays
              </li>
              <li className="flex gap-3" data-id="element-176">
                <span className="text-forest" data-id="element-177">✓</span>
                Quieres claridad rápida, no motivación
              </li>
              <li className="flex gap-3" data-id="element-178">
                <span className="text-forest" data-id="element-179">✓</span>
                Tienes bills fijos + gastos variables que te desordenan
              </li>
              <li className="flex gap-3" data-id="element-180">
                <span className="text-forest" data-id="element-181">✓</span>
                Quieres dejar de pagar cargos por "no haber visto venir"
              </li>
            </ul>
          </div>
          <div data-id="element-182">
            <h3 className="text-xl font-bold text-warm-red mb-6 uppercase tracking-wide" data-id="element-183">
              No es para ti si:
            </h3>
            <ul className="space-y-3 text-charcoal/90" data-id="element-184">
              <li className="flex gap-3" data-id="element-185">
                <span className="text-warm-red" data-id="element-186">✕</span>
                Buscas inversiones o "hacer dinero rápido"
              </li>
              <li className="flex gap-3" data-id="element-187">
                <span className="text-warm-red" data-id="element-188">✕</span>
                Quieres un sistema que funcione sin mirar números
              </li>
              <li className="flex gap-3" data-id="element-189">
                <span className="text-warm-red" data-id="element-190">✕</span>
                Necesitas un plan profundo de deudas (esto es primero:
                estabilidad)
              </li>
            </ul>
          </div>
        </div>

        {/* Transformation */}
        <div className="text-center mb-16 max-w-2xl mx-auto" data-id="element-191">
          <h3 className="text-2xl font-serif text-charcoal mb-8" data-id="element-192">
            Lo que puedes sentir después de 1 payday
          </h3>
          <div className="space-y-4 text-lg text-charcoal/80" data-id="element-193">
            <p data-id="element-194">Abres el banco y no te golpea el pecho.</p>
            <p data-id="element-195">Sabes lo que toca pagar.</p>
            <p data-id="element-196">Sabes lo que está protegido.</p>
            <p data-id="element-197">Y si algo no cabe… no negocias contigo misma por 40 minutos.</p>
            <p className="font-medium text-forest" data-id="element-198">
              Porque ya tienes la respuesta.
            </p>
          </div>
        </div>

        {/* Pricing Card */}
        <motion.div initial={{
        scale: 0.95,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-2xl overflow-hidden max-w-lg mx-auto border border-warm-gray/10 relative" data-id="element-199">
          {/* Price Anchoring Banner */}
          <div className="bg-cream border-b border-warm-gray/10 p-4 text-center text-sm font-medium" data-id="element-200">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-0" data-id="element-201">
              <span className="text-warm-red" data-id="element-202">1 overdraft = $35</span>
              <span className="mx-2 text-warm-gray hidden sm:inline" data-id="element-203">·</span>
              <span className="text-warm-red" data-id="element-204">1 late fee = $29</span>
              <span className="mx-2 text-warm-gray hidden sm:inline" data-id="element-205">·</span>
              <span className="text-forest font-bold" data-id="element-206">
                Este sistema = $6.36
              </span>
            </div>
          </div>

          <div className="bg-forest p-4 text-center text-white text-sm font-medium tracking-wide" data-id="element-207">
            AHORRA HASTA $28 VS. UN SOLO SOBREGIRO
          </div>
          <div className="p-8 md:p-12 text-center" data-id="element-208">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-2" data-id="element-209">
              El Mapa de Pago en 10 Min
            </h2>
            <p className="text-warm-gray mb-4" data-id="element-210">Edición Cero Sobregiros</p>
            <p className="text-sm text-charcoal/70 italic mb-8 max-w-xs mx-auto" data-id="element-211">
              Tu sistema de 1 página para saber qué sí puedes gastar—sin
              registrar cada compra.
            </p>

            <div className="flex items-center justify-center gap-3 mb-1" data-id="element-212">
              <span className="text-2xl text-warm-gray line-through" data-id="element-213">$19</span>
              <span className="text-5xl font-bold text-charcoal" data-id="element-214">$6.36</span>
              <span className="text-warm-gray text-lg" data-id="element-215">USD</span>
            </div>
            <div className="mb-2" data-id="element-216">
              <span className="inline-block bg-forest/10 text-forest text-sm font-bold px-3 py-1 rounded-full" data-id="element-217">
                Ahorras $12.64 — 67% de descuento
              </span>
            </div>
            <p className="text-sm text-warm-gray mb-8 uppercase tracking-wide" data-id="element-218">
              Pago único
            </p>

            <div className="space-y-2 mb-10 text-sm text-charcoal/70" data-id="element-219">
              <p data-id="element-220">Menos que un café con leche.</p>
              <p data-id="element-221">
                Menos que{' '}
                <span className="font-semibold text-warm-red" data-id="element-222">
                  un solo overdraft te cobra $35
                </span>
                .
              </p>
            </div>

            <Button fullWidth className="mb-6 text-xl py-5" id="checkout" href="https://www.betterbysteps.com/cart/44195951870045:1" data-id="element-223">
              Descarga tu Mapa de Pago Ahora
            </Button>

            <p className="text-xs text-warm-gray" data-id="element-224">
              Entrega digital inmediata • Acceso de por vida
            </p>
          </div>
        </motion.div>

        <div className="mt-16 text-center max-w-xl mx-auto" data-id="element-225">
          <p className="text-lg text-charcoal mb-6" data-id="element-226">
            Si quieres que tu próximo payday se sienta como{' '}
            <span className="font-bold" data-id="element-227">claridad</span> (no como pánico), este
            es tu sistema.
          </p>
          <p className="font-serif text-lg md:text-xl text-forest mb-8 whitespace-nowrap" data-id="element-228">
            Haz tu LÍNEA SEGURO‑PARA‑GASTAR hoy.
          </p>

          <Button className="bg-forest/90 text-base px-8 py-3" scrollTo="checkout" data-id="element-229">
            Descargar — $6.36
          </Button>
        </div>
      </div>
    </section>;
}